<template>
    <div :class="b()">
        <div class="col-sm-12">
            <div class="white-card">
                <div class="row">
                    <!-- Image Block -->
                    <div class="col-sm-12 col-md-5">
                        <div class="image-set item__image-set">
                            <div class="image-set__preview">
                                <div @click="prevImage" class="img-left"><span class="fa fa-angle-left"></span></div>
                                <img :src="currentImage" @error="$event.target.src='/images/no-photo.png'" alt="" id="imageSetPreviewImage">
                                <div @click="nextImage" class="img-right"><span class="fa fa-angle-right"></span></div>
                            </div>
                            <div v-if="category.images.length > 0" class="image-set__thumbs">
                                <img v-for="(image, index) in category.images"
                                     :key="index"

                                     :class="['image-set__thumb', (activeImage === index) ? 'active' : '']"
                                     :src="image.image"
                                     alt="medved" v-on:click="activateImage(index)"
                                     @error="$event.target.src='/images/no-photo.png'">

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-7">
                        <div class="row">
                            <div class="col-sm-12 item__data">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="item__header">{{ category.title }}</div>
                                    </div>

                                    <!-- Временная заглушка, пока курс скачет. Потом удалить условия -->
                                    <template v-if="category.isProtectedRole">
                                        <div class="col-sm-12">
                                            <div class="item__prices">
                                                <span v-html="resultPrice"></span>
                                                <div>Единицы измерения: {{ this.category.unit }}</div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="dropdown">
                                                <div class="link toggleAnotherVisible" type="button"
                                                     @click="toggleAnotherVisiblePrice" aria-haspopup="true"
                                                     aria-expanded="false">
                                                    Подробнее о цене и доставке: <i class="fa fa-angle-down"></i>
                                                </div>
                                                <div v-show="priceMoreVisible" aria-labelledby="morePriceBtn">
                                                    <div class="aboutPrice">
                                                        <p>Цена является среднерыночной и основывается на прайсах наших
                                                            поставщиков.</p>
                                                        <p>При выборе характеристик товара она будет меняться и
                                                            формироваться на
                                                            основании цен только тех товаров, которые соответствуют
                                                            указанным
                                                            характеристикам.</p>
                                                        <p>Сформированная цена станет стартовой в торгах и будет
                                                            снижаться
                                                            при
                                                            каждом ходе поставщика.</p>
                                                        <p>Доставка бесплатна до терминала вашего города.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="category.isBuyerUser">
                                            <div class="col-sm-12 items__add-block">
                                                <form v-if="userId" id="toCart" class="item__add-form"
                                                      @submit="addToCart">
                                                    <input :id="'item-' + itemAncestorId" type="hidden"
                                                           :value="itemAncestorId">
                                                    <number-counter v-model="productCount"></number-counter>
                                                </form>
                                                <template v-if="!!sumPrice">
                                                    <div class="item__sum">
                                                        Общая цена:
                                                    </div>
                                                    <div class="item__sum-price">
                                                        <span v-html="sumPrice"></span><i class="fa fa-ruble"></i>
                                                    </div>
                                                </template>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="dropdown">
                                                    <div class="link toggleAnotherVisible" type="button"
                                                         @click="toggleAnotherVisibleUnit" aria-haspopup="true"
                                                         aria-expanded="false">
                                                        Подробнее о количестве: <i class="fa fa-angle-down"></i>
                                                    </div>
                                                    <div v-show="unitMoreVisible" aria-labelledby="morePriceBtn">
                                                        <div class="aboutPrice">
                                                            <p>Если выбранное количество товара не кратно упаковке, по
                                                                результатам торгов оно будет автоматически изменено до
                                                                ближайшего кратного значения.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <button type="submit" form="toCart"
                                                        class="btn -color-green to-cart-btn text-uppercase">Добавить в
                                                    корзину
                                                </button>
                                            </div>

                                            <template v-if="!this.category.isDemoUser">
                                                <div class="col-sm-6">
                                                    <div v-if="userId" class="item__favorite link"
                                                         @click="addToFavorite(catId, userId)">
                                                        <i class="fa"
                                                           v-bind:class="{ 'fa-heart-o': isFavorite === false, 'fa-heart primary-color': isFavorite === true }"></i>
                                                        В избранное
                                                    </div>
                                                </div>
                                            </template>

                                        </template>
                                        <template v-else-if="category.isSellerUser">
                                            <div class="col-sm-12">
                                                <number-counter v-model="productCount"></number-counter>
                                                <button class="btn -color-blue mb-3" href="#" data-target="#wantModal"
                                                        data-toggle="modal">Отправить прайс
                                                </button>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <div class="col-md-12">
                                            <div class="alert alert-danger" role="alert">
                                                В связи с изменениями курса валют и сложной эпидемиологической ситуацией стоимость медицинских расходных материалов постоянно обновляется. Чтобы узнать цену на текущий момент и разместить закупку, пожалуйста, свяжитесь с нами по телефону горячей линии:
                                                <strong><a href="tel:88005551120">8 (800) 555-11-20</a></strong>
                                            </div>
                                        </div>
                                    </template>

                                </div>
                            </div>

                            <div id="disabledBlockWrap" class="col-sm-12">
                                <!--                                <hr class="divider">-->
                                <i class="fa fa-spinner fa-spin spinner-center"></i>
                                <div id="disabledBlock">
                                    <a href="" class="filter-reset"><i class="fa fa-filter"></i> сбросить фильтр</a>
                                    <div class="item__heading">Выберите основные характеристики:</div>
                                    <div v-for="mainAttribute in category.mainAttributes"
                                         class="item__attr attr-select"
                                         :data-attribute-id="mainAttribute.id">
                                        <div class="attr-select__title">{{ mainAttribute.title }}</div>
                                        <label v-for="possibleValue in mainAttribute.possibleValues"
                                               @click="setSelectedAttribute(mainAttribute, possibleValue)"
                                               :class="selectItemClass(mainAttribute.id, possibleValue.id)"
                                               :data-possible-id="possibleValue.id">
                                            {{ possibleValue.value }}
                                        </label>
                                        <label :class="b('remove-filter')" @click="removeSelected(mainAttribute)"><i
                                                class="fa fa-times"></i></label>
                                    </div>
                                    <div class="dropdown">
                                        <div class="link item__heading" type="button" @click="toggleAnotherVisible"
                                             aria-haspopup="true"
                                             aria-expanded="false">
                                            Дополнительные характеристики: <i class="fa fa-angle-down"></i>
                                        </div>
                                        <div v-show="anotherVisible" aria-labelledby="moreAttrsBtn">
                                            <div v-for="anotherAttribute in category.anotherAttributes"
                                                 class="item__attr attr-select"
                                                 :data-attribute-id="anotherAttribute.id">
                                                <div class="attr-select__title">{{ anotherAttribute.title }}</div>
                                                <label v-for="possibleValue in anotherAttribute.possibleValues"
                                                       @click="setSelectedAttribute(anotherAttribute, possibleValue)"
                                                       :class="selectItemClass(anotherAttribute.id, possibleValue.id)"
                                                       :data-possible-id="possibleValue.id">
                                                    {{ possibleValue.value }}
                                                </label>
                                                <label :class="b('remove-filter')"
                                                       @click="removeSelected(anotherAttribute)"><i
                                                        class="fa fa-times"></i></label>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import BuyingService from "../services/BuyingService";
import FavoriteService from "../services/FavoriteService";
import NumberCounterComponent from "./NumberCounterComponent";
import CategoryService from "../services/CategoryService";

const COMPONENT_NAME = "prototype-card";

export default {
  components: {
    NumberCounterComponent,
  },
  props: [
    'catId',
    'itemAncestorId',
            'userId',
            'favoriteId',
        ],
        name: COMPONENT_NAME,
        data() {
            return {
                category: {
                    mainAttributes: [],
                    anotherAttributes: [],
                    images: [],
                    minPrice: '',
                    maxPrice: '',
                    unit: '',
                },
                isFavorite: false,
                favorite: [],
                selectedAttributes: {},
                productCount: 1,
                anotherVisible: false,
                priceMoreVisible: false,
                unitMoreVisible: false,
                resultPrice: '',
                sumPrice: null,
                resultValues: '',
                activeImage: 0
            };
        },
        mounted() {
            this.getCategory();
        },
        computed: {
            currentImage() {
                if (this.category.images.length > 0) {
                    return this.category.images[this.activeImage]['image'];
                } else {
                    return this.$LOGO_CAT_NO_FOUND;
                }
            }
        },
        methods: {
            async addToCart(event) {
                event.preventDefault();
                let canAdd = true;
                let $message, $text, $href, $type;

                this.category.mainAttributes.forEach((element) => {
                    if (!this.selectedAttributes.hasOwnProperty(element.id)) {
                        canAdd = false;
                    }
                });

                if (!canAdd) {
                    this.$notify({message: 'Должны быть выбраны все основные характеристики', type: 'error'});
                    return;
                }

                if (this.category.isDemoUser) {
                    this.$notify({
                        message: 'Для добавления товаров в корзину необходимо зарегистрироваться!',
                        type: 'error'
                    });
                    $('.signupBuyer').click();
                    return;
                }

                let response = await BuyingService.addToBuying(this.itemAncestorId, this.selectedAttributes, this.$children[0].currentValue);
                if (response.success) {
                    this.createDOM(
                        $message = 'Товар добавлен в ',
                        $text = 'корзину',
                        $href = '/buyer/buying-list/index',
                        $type = 'success'
                    );

                    // Обновим корзину в шапке
                    updateBuyingListSum();
                }
            },
            async addToFavorite() {
                event.preventDefault();

                let canAdd = true;

                this.category.mainAttributes.forEach((element) => {
                    if (!this.selectedAttributes.hasOwnProperty(element.id)) {
                        canAdd = false;
                    }
                });

                if (!canAdd) {
                    this.$notify({message: 'Должны быть выбраны все основные характеристики'});
                    return;
                }

                this.isFavorite = true;
                this.blockedWrapAttribute(true);

                let response = await FavoriteService.addToFavorite(this.itemAncestorId, this.selectedAttributes);
                let $message, $text, $href, $type;
                // this.isFavoriteAttributes();

                if (response.success) {
                    this.createDOM(
                        $message = 'Товар добавлен в ',
                        $text = 'избранное',
                        $href = '/buyer/favorite/prototypes',
                        $type = 'success'
                    );
                } else {
                    this.createDOM(
                        $message = 'Данный товар уже в ',
                        $text = 'избранном',
                        $href = '/buyer/favorite/prototypes',
                        $type = 'fail'
                    );

                }
                this.blockedWrapAttribute(false);
            },
            async isFavoriteAttributes() {
                let response = await FavoriteService.isFavoriteAttributes(this.itemAncestorId, this.selectedAttributes);
                if (response.success) {
                    this.isFavorite = true;
                } else {
                    this.isFavorite = false;
                }
            },
            async getCategory() {
                let response = await CategoryService.getCategory(this.catId);
                if (response.success) {
                    this.category = response.category;
                    this.resultPrice = this.priceText('periodPrice');
                    //Проверяем Url и получаем избранные аттрибуты
                    this.getUrl();
                }
            },
            async createDOM($message, $text, $href, $type) {
                let text = this.$createElement('span', $message, {
                    children: href
                });

                let href = this.$createElement('a', {
                    domProps: {
                        innerHTML: $text,
                        href: $href
                    },
                });

                let message = this.$createElement('div', [
                    text, href
                ]);

                this.$notify({message: message, type: $type});
            },
            priceText(method) {
                if (method === 'periodPrice') {
                    return 'Стартовая цена: от ' + this.category.minPrice + ' - до ' + this.category.maxPrice;
                } else if (method === 'maxPrice') {
                    this.sumPriceText();
                    return 'Стартовая цена: ' + this.category.maxPrice;
                }
            },
            sumPriceText() {
              console.log(this.$children);
                if (!this.resultPrice.includes(" - ")) {
                    this.sumPrice = this.$children[0].currentValue * this.category.maxPrice;
                } else {
                    this.sumPrice = null;
                }
            },
            blockedWrapAttribute(method) {
                if (method === true) {

                    $('#disabledBlock').addClass('disabled');
                    $('#disabledBlockWrap .spinner-center').show();
                } else {
                    $('#disabledBlock').removeClass('disabled');
                    $('#disabledBlockWrap .spinner-center').hide();
                }
            },
            async setSelectedAttribute(attribute = null, possibleValue = null) {

                if (!!attribute && !!possibleValue) {

                    // Если атрибут заблокирован, то и нажать на него нельзя
                    let curAttr = $('.attr-select__item[data-possible-id = "' + possibleValue.id + '"]');
                    if (curAttr.hasClass('blocked')) {
                        return;
                    }

                    // Текущий родитель последнего выбранного аттрибута
                    $('.attr-select').removeClass('parent-click-attr');
                    curAttr.parent('.attr-select').addClass('parent-click-attr');

                    this.setAttribute(attribute.id, possibleValue.id);
                }

                // Отправляем запрос для получения активных атрибутов по которым присутствует товар
                this.getAvailableAttributes();
            },
            async blockAttributes(resultAttributesCombine) {
                $('.attr-select__item').each(function (i, obj) {

                    let possible_id = $(obj).attr('data-possible-id');
                    if (resultAttributesCombine.indexOf(parseInt(possible_id)) == -1) {
                        if (!$(obj).parent('.attr-select').hasClass('parent-click-attr')) {
                            $(obj).addClass('blocked');
                        }
                    } else {
                        $(obj).removeClass('blocked');
                    }
                });
            },
            selectItemClass(attributeId, possibleValueId) {
                let $class = 'attr-select__item' + (
                    this.selectedAttributes[attributeId] == possibleValueId ? ' attr-select__item_active' : ''
                );

                return $class;
            },
            toggleAnotherVisible() {
                this.anotherVisible = !this.anotherVisible;
                // this.priceMoreVisible = !this.priceMoreVisible;
            },
            toggleAnotherVisiblePrice() {
                // this.anotherVisible = !this.anotherVisible;
                this.priceMoreVisible = !this.priceMoreVisible;
            },
            toggleAnotherVisibleUnit() {
                // this.anotherVisible = !this.anotherVisible;
                this.unitMoreVisible = !this.unitMoreVisible;
            },
            async removeSelected(attribute) {
                let attrDel = [];
                attrDel.push(attribute.id);
                let curAttr = $('.item__attr[data-attribute-id = "' + attribute.id + '"]');
                let curAttrNextAll = curAttr.nextAll('.item__attr');
                curAttrNextAll.each(function (index, element) {
                    attrDel.push($(element).data('attribute-id'));
                });
                let dropdownAttr = curAttr.nextAll('.dropdown');
                if (dropdownAttr.length) {
                    let curAttrDropdownNextAll = dropdownAttr.find('.item__attr');
                    curAttrDropdownNextAll.each(function (index, element) {
                        attrDel.push($(element).data('attribute-id'));
                    });
                }

                let oldSelectedAttributes = this.selectedAttributes;
                attrDel.forEach(function (item) {
                    delete oldSelectedAttributes[parseInt(item)];
                });

                this.favorite = '';
                let newSelectedAttributes = Object.assign({}, oldSelectedAttributes);
                this.$set(this, 'selectedAttributes', newSelectedAttributes);
                this.setSelectedAttribute();
            },

            nextImage() {
                let active = this.activeImage + 1;
                if (active >= this.category.images.length) {
                    active = 0;
                }
                this.activateImage(active);
            },
            prevImage() {
                let active = this.activeImage - 1;
                if (active < 0) {
                    active = this.category.images.length - 1;
                }
                this.activateImage(active);
            },
            activateImage(imageIndex) {
                this.activeImage = imageIndex;
            },
            async setAttribute(attributeId, valueId) {
                let oldSelectedAttributes = this.selectedAttributes;
                oldSelectedAttributes[attributeId] = valueId;
                let newSelectedAttributes = Object.assign({}, oldSelectedAttributes);
                this.$set(this, 'selectedAttributes', newSelectedAttributes);
            },
            async getAvailableAttributes() {

                // Добавляем общую блокировку ко всему блоку атрибутов если произошел выбор
                this.blockedWrapAttribute(true);
                this.isFavoriteAttributes();

                let response = await CategoryService.getAvailableAttributes(this.category['id'], this.selectedAttributes);

                if (response.success) {
                    let resultAttributesCombine = Object.values(response.resultAttributesCombine);
                    this.category.maxPrice = response.resultMaxPrices;
                    this.category.minPrice = response.resultMinPrices;
                    this.category.images = response.resultImages;

                    if (Object.keys(this.selectedAttributes).length) {
                        this.resultPrice = this.priceText('maxPrice');
                    } else {
                        this.resultPrice = this.priceText('periodPrice');
                    }
                    this.sumPriceText();

                    this.blockAttributes(resultAttributesCombine);

                    // Убираем блокировку всего блока
                    this.blockedWrapAttribute(false);
                } else {
                    alert('Произошла ошибка, повторите попытку');
                    location.reload();
                }
            },
            async getUrl() {
                if (this.favoriteId) {
                    let favoriteResponse = await FavoriteService.getFavoriteById(this.favoriteId);
                    if (favoriteResponse.success) {
                        this.favorite = favoriteResponse.favorite.attributes_and_values;

                        for (let attAndVal of this.favorite) {
                            //Устанавливаем избранное занчение для каждого аттрибута
                            this.setAttribute(attAndVal['attribute_id'], attAndVal['attribute_possible_value_id']);
                        }

                        // Отправляем запрос для получения активных атрибутов по которым присутствует товар
                        this.getAvailableAttributes();
                    }
                }
            },
            openRegister(isSeller) {
                if (isSeller) {
                    $('.signupSeller').click();
                } else {
                    $('#signup-modal').modal('show');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .prototype-card {


        &__remove-filter {
            &:hover {
                cursor: pointer;
                color: #c7004a;
            }

            color: #8a8a8a;
            text-decoration: underline;
            border-bottom: none;
            font-size: 12px;
            line-height: 20px;
        }

        .image-set__thumb {
            opacity: 0.4;
        }

        .image-set__thumb.active {
            opacity: 1;
        }

        .attr-select__item.blocked {
            background: #e0e2e4;
            cursor: not-allowed;
            opacity: 0.3;
        }

        .filter-reset {
            &:hover {
                color: #c7004a;
            }

            margin-bottom: 15px;
            display: block;
        }

        .fa-question-circle-o {
            &:hover {
                color: #c7004a;
            }

            color: #337ab7;
        }

        .toggleAnotherVisible {
            color: #c7004a;
            margin-bottom: 10px;
            font-size: 14px;
        }

        .aboutPrice {
            font-size: 14px;
        }
    }
</style>